import React, { useRef, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
// import { Auth } from 'aws-amplify';
import SideBar from '../components/SideBar';
import DashboardContainer from '../containers/DashboardContainer';
import DashboardHistoryContainer from '../containers/DashboardHistoryContainer';
import SettingsContainer from '../containers/SettingsContainer';
import { connect } from 'react-redux';
import {
  getAssets,
  getConfigFile,
  setFilteredAssets,
  setFilters,
  saveAuthentication
} from '../actions';

import MetricsContainer from './MetricsContainer';
import { AmplifyAuthenticator, AmplifySignOut, AmplifyGreetings, AmplifySignIn } from '@aws-amplify/ui-react';
import { onAuthUIStateChange, Translations } from '@aws-amplify/ui-components';
import logo from '../assets/icon.png';
import { I18n } from 'aws-amplify';

I18n.putVocabulariesForLanguage('es', {
  [Translations.SIGN_IN_HEADER_TEXT]: 'Iniciar sesión en su cuenta',
  [Translations.SIGN_IN_ACTION]: 'INICIAR SESIÓN',
  [Translations.USERNAME_LABEL]: 'Nombre de usuario *',
  [Translations.USERNAME_PLACEHOLDER]: 'Introduzca su nombre de usuario',
  [Translations.PASSWORD_LABEL]: 'Contraseña *',
  [Translations.PASSWORD_PLACEHOLDER]: 'Introduzca su contraseña',
  [Translations.FORGOT_PASSWORD_TEXT]: '¿Olvidó su contraseña?',
  [Translations.RESET_PASSWORD_TEXT]: 'Reestablecer contraseña',
  [Translations.RESET_YOUR_PASSWORD]: 'Reestablezca su contraseña',
  [Translations.BACK_TO_SIGN_IN]: 'Volver a iniciar sesión',
  [Translations.SEND_CODE]: 'Enviar código',
  [Translations.CONFIRM_SMS_CODE]: 'Confirmar código SMS',
  [Translations.CODE_LABEL]: 'Código de verificación',
  [Translations.CODE_PLACEHOLDER]: 'Introduzca el código',
  [Translations.CONFIRM]: 'CONFIRMAR'
});

const MainContainer = (props) => {
  const { authenticated, setAuthentication } = props;
  const [authState, setAuthState] = useState();
  const [userRol, setUserRol] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    return onAuthUIStateChange((nextAuthState, authData) => {
      if (nextAuthState === 'signedin') {
        setAuthentication(true);
        setUserRol(authData.signInUserSession.idToken.payload.role);
      }
      setAuthState(nextAuthState);
    });
  }, [setAuthentication]);

  if (!props.Assets) {
    return <>Loading</>;
  }
  return authenticated ? (
    <div style={{ display: 'flex', overflow: 'hidden' }}>
      <Router>
        <SideBar configFile={props.configFile} />
        <div
          className='bx--grid bx--grid--full-width'
          ref={ref}
          style={{ flex: 2 }}
        >
          <div className='bx--row' style={{ height: '100%', width: '100%' }}>
            <div className='bx--col' style={{ height: '100%', width: '100%' }}>
              {/* OJO!!! el orden de los route es importante!! */}
              <Switch>
                <Route exact path='/dashboard' component={DashboardContainer} />
                <Route exact path='/metrics' component={MetricsContainer} />
                <Route
                  exact
                  path='/asset/:id'
                  component={DashboardHistoryContainer}
                />
                <Route
                  exact
                  path='/settings'
                  component={userRol ? SettingsContainer : DashboardContainer}
                />
                <Redirect from='/' to='/dashboard' />
              </Switch>
            </div>
          </div>
        </div>
      </Router>
    </div>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      {authState !== 'signedin' && authState !== 'verifyContact' && <img src={logo} width={150} height={150} alt='URUK' style={{ marginBottom: 43 }} />}
      <AmplifyAuthenticator hide={[AmplifySignOut, AmplifyGreetings]} initialAuthState='signin'>
        <AmplifySignIn slot='sign-in' hideSignUp />
      </AmplifyAuthenticator>
    </div>
  );
};

const mapStateToProps = state => ({
  assets: state.assets,
  configFile: state.configFile,
  filters: state.filters,
  filteredAssets: state.filteredAssets,
  authenticated: state.authenticated
});

const mapDispatchToPropsActions = dispatch => ({
  Assets: (value, tokenRol) => dispatch(getAssets(value)),
  ConfigFile: (value) => dispatch(getConfigFile(value)),
  Filters: value => dispatch(setFilters(value)),
  FilteredAssets: value => dispatch(setFilteredAssets(value)),
  setAuthentication: (data) => dispatch(saveAuthentication(data))
});

export default connect(mapStateToProps, mapDispatchToPropsActions)(MainContainer);
